import React, { Component } from 'react';
import * as api from '../../services/api';
import { message, Tooltip } from 'antd';
import './index.scss';
import urlparser from 'urlparser';
import ReactGA from 'react-ga';
import QRCode from 'qrcode.react';

interface IState {
  title: string,
  gallery: string,
  id: string,
  type: string,
  shareItems: Array<any>
}

interface IProps {

}

class ContentShare extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      title: '',
      gallery: '',
      id: '',
      type: '',
      shareItems: []
    };
  }

  async componentDidMount() {
    ReactGA.initialize('UA-120859875-1');
    ReactGA.set({ page: window.location.pathname + window.location.search });
    ReactGA.pageview(window.location.pathname + window.location.search);
    await this.size();
    let queryParamsUrl = urlparser.parse(window.location.href).query;
    let queryParams = queryParamsUrl && queryParamsUrl.params as any;
    let inviteId = queryParams ? queryParams.inviterId : '';
    let contentId = queryParams ? queryParams.contentId : '';
    let source = queryParams ? queryParams.source : '';
    if (contentId) {
      let data = await api.contentShareItems(contentId, inviteId, source);
      let detailData = await api.contentShareDetail(contentId);
      if (!data.error && !detailData.error) {
        this.setState({
          title: detailData.body && detailData.body.title,
          gallery: detailData.body && detailData.body.gallery,
          id: detailData.body && detailData.body.id,
          type: detailData.body && detailData.body.type,
          shareItems: data.body && data.body
        });
      } else {
        if (detailData.error) {
          message.error(detailData.error);
        } else {
          message.error(data.error);
        }

      }
    }
  }


  size = (): void => {
    let _html = document.getElementsByTagName('html')[0];
    let view_width = document.getElementsByTagName('html')[0].getBoundingClientRect().width;
    view_width > 1650 ? _html.style.fontSize = 1650 / 165 + 'px' : _html.style.fontSize = view_width / 1650 * 10 + 'px';
  };
  openShare = async (link: string, type: string) => {
    let queryParamsUrl = urlparser.parse(window.location.href).query;
    let queryParams = queryParamsUrl && queryParamsUrl.params as any;
    let inviteId = queryParams ? queryParams.inviterId : '';
    let contentId = queryParams ? queryParams.contentId : '';
    let source = queryParams ? queryParams.source : '';
    if (!sessionStorage.getItem(contentId)) {
      let recordData = await api.recordShare(contentId, inviteId ? {
        type: type,
        userId: inviteId,
        source: source ? source : null
      } : { type: type, source: source ? source : null });
      if (!recordData.error) {
        sessionStorage.setItem(contentId, 'true');
      }
    }
    window.open(link);
  };

  render() {
    const { title, gallery, id, type, shareItems } = this.state;
    return (
      <div className={'content-share-wrap'} style={{ height: window.document.documentElement.clientHeight }}>
        <div className={'content-share-top'}>
          <div className={'content-share-top-content'}><img src={require('../../assets/logo.png')} alt=""/>iSlide</div>
        </div>
        <div className={'content-share-content-wrap'}>
          <div className={'content-share-box'}>
            {
              title ? <h3 className={'content-share-head'}>{title}</h3> : null
            }
            <img className={'content-share-img'} src={gallery} alt=""/>
            <div className={'content-share-content-ways'}>
              <h4 className={'content-share-id'}><span>资源 ID</span><span>{id}</span></h4>
              <h5 className={'content-share-title'}><span>分享方式</span>
                <div className={'content-share-items'}>
                  {
                    shareItems.map(item => {
                      return item.isQrCode ? <Tooltip className={'content-share-tooltip'} key={item.type}
                                                      title={<div className={'content-share-qrcode'}>
                                                        {
                                                          item.miniProgramCodeBase64?<div  style={{width:'11rem',height:'11rem',background:`url(${item.miniProgramCodeBase64}) no-repeat center center`,backgroundSize:'cover'}}/>:<QRCode
                                                            value={item.link}
                                                            size={1000}/>
                                                        }
                                                        <span>微信扫码分享</span>
                                                      </div>}><img style={{ cursor: 'pointer',position:'relative' }}
                                                                   src={item.icon} alt=""/></Tooltip> :
                        <span key={item.type} className={'content-share-right-item'}
                              onClick={this.openShare.bind(this, item.link, item.type)}><img src={item.icon}
                                                                                             alt=""/></span>;
                    })
                  }
                </div>
              </h5>
            </div>

          </div>
        </div>
      </div>
    );
  }
}

export default ContentShare;

